const fg_no_states = [ 'AK', 'HI', 'MS', 'RI', 'SD', 'UT' ];

const fg_wh_states = {
    "etc": [ 'AL','AK','GA','IL','ID','IA','KS','KY','LA','MI','MN','MS','MO','NE','ND','OH','OK','SD','TN','TX','WV','WI' ],
    "cob": [ 'CT','DE','DC','FL','ME','MD','MA','NH','NJ','NY','NC','PA','RI','SC','VT','VA' ],
    "vcx": [ 'AZ','CA','CO','HI','ID','MT','NV','NM','OR','UT','WA','WY' ]
}

// If the user selected a state, set the current WH
var fg_wh = '';

function setCurrentWarehouse() {
    const currentState = window.localStorage.getItem('fgw_state');
    if (currentState) {
        // in entries: 0 is key, 1 is value
        const entryForState = Object.entries(fg_wh_states).find((anEntry) => anEntry[1].includes(currentState));
        if (entryForState) {
            fg_wh = entryForState[0];
        } else {
            fg_wh = '';
        }
    }
}

function updateATCButtons(pdpATCButtons, plpATCButtons, getAgainATCButtons, text) {
    if (pdpATCButtons) pdpATCButtons.forEach((el) => {
        el.querySelector("span.single-add-to-cart-button--text").innerHTML = text;
    });
    if (plpATCButtons) plpATCButtons.forEach((el) => {
        el.querySelector("span.product-card--add-to-cart-text").innerHTML = text;
    });
    if (getAgainATCButtons) getAgainATCButtons.forEach((el) => {
        el.querySelector("span.product-card--add-to-cart-text").innerHTML = text;
    });
}

function enableAvailabilityElements() {
    const pdpSubSaveBtn = document.querySelector('.subscribe-and-save-button');
    const pdpATCButtons = document.querySelectorAll('button#AddToCart');
    const plpATCButtons = document.querySelectorAll('button.product-card--add-to-cart-button');
    const getAgainATCButtons = document.querySelectorAll('.button.reorder');
    const atcButtons = [...pdpATCButtons,...plpATCButtons, ...getAgainATCButtons];
    const qtyButtons = document.querySelectorAll('quantity-selector > button');
    const qtyInput = document.querySelectorAll('quantity-selector > input');
    const targets = [...atcButtons,...qtyButtons,...qtyInput];
    // do not do any of this for cart elements.
    targets.forEach((t) => {
        if (!t.closest(`cart-drawer`) && !t.closest(`#Cart`)) {
            t.removeAttribute('disabled');
        }
    });
    if(pdpSubSaveBtn) {
        pdpSubSaveBtn.classList.remove('disabled');
    }

    updateATCButtons(pdpATCButtons, plpATCButtons, null, 'Add to Cart')
    updateATCButtons(null, null, getAgainATCButtons, 'Reorder')

    // hide all "item cannot ship to your state" elements
    document.querySelectorAll('[data-unavailable-state]').forEach((el) => {
        el.setAttribute('hidden', true);
        const thingToDisable = el.closest('[data-unavailable-disable]');
        const thingToCover = el.parentElement.querySelector('[data-unavailable-cover]');
        if (thingToDisable) thingToDisable.classList.remove('unavail_disable');
        if (thingToCover) thingToCover.classList.remove('unavail_cover');
    });

    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
        // enable variant selects
        variantSelects.classList.remove('unavail_disable');
        variantSelects.classList.remove('unavail_cover');
    }

}

function fgDisableElements(elements, buttonText) {
    for(const anElement of elements) {
        const productForm = anElement.closest('product-form');
        const productCard = anElement.closest('product-card');
        const getAgainCard = anElement.closest('.get-again-card');
        let pdpATCButtons = [];
        let plpATCButtons = [];
        let getAgainATCButtons = [];
        const pdpSubSaveBtn = document.querySelector('.subscribe-and-save-button');
        let atcButtons = [];

        if(pdpSubSaveBtn) {
            pdpSubSaveBtn.classList.add('disabled');
        }

        if (productForm) {
            pdpATCButtons = productForm.querySelectorAll('button#AddToCart');
            pdpATCButtons.forEach((b) => atcButtons.push(b));
        }
        if (productCard) {
            plpATCButtons = productCard.querySelectorAll('button.product-card--add-to-cart-button');
            plpATCButtons.forEach((b) => atcButtons.push(b));
        }
        if (getAgainCard) {
            getAgainATCButtons = getAgainCard.querySelectorAll('.button.reorder');
            getAgainATCButtons.forEach((b) => atcButtons.push(b));
        }
        const qtyButtons = anElement.parentElement.querySelectorAll('quantity-selector > button');
        const qtyInput = anElement.parentElement.querySelectorAll('quantity-selector > input');
        const targets = [...atcButtons,...qtyButtons,...qtyInput];
        targets.forEach((t) => t.setAttribute('disabled', ""));
        if (buttonText) {
            updateATCButtons(pdpATCButtons, plpATCButtons, getAgainATCButtons, buttonText)
        }
        const thingToDisable = anElement.closest('[data-unavailable-disable]');
        const thingToCover = anElement.parentElement.querySelector('[data-unavailable-cover]');
        if (thingToDisable) thingToDisable.classList.add('unavail_disable');
        if (thingToCover) thingToCover.classList.add('unavail_cover');

        var variantSelects = anElement.closest('variant-selects');
        if (variantSelects) {
            // enable variant selects, we assume there is only one
            variantSelects.classList.add('unavail_disable');
            variantSelects.classList.add('unavail_cover');
        }

    }
}

function showUnavailable(elements) {
    for(const anElement of elements) {
        const el = anElement.parentElement.querySelector('[data-unavailable-state]');
        if (el) {
            el.removeAttribute('hidden');
        }
    }
}
function fgCheckAvailability() {
    enableAvailabilityElements();
    let unavailableByState = [];
    let unavailableByWh= [];

    // disable based on selected state (compliance)
    if (fgCurrentState()) {
        const states = document.querySelectorAll('[data-fg-states]');
        for (var anElement of states) {
            if (!anElement.dataset.fgStates || !anElement.dataset.fgStates.includes(fgCurrentState())) {
                unavailableByState.push(anElement);
            }
        }
        // show "Item unavailable in your state" elements
        console.log(`Disabling ${unavailableByState.length} wines not available in state ${fgCurrentState()}`);
        fgDisableElements(unavailableByState);
        showUnavailable(unavailableByState);
    }

    // disable based on WH (sold out)
    const whs = document.querySelectorAll('[data-fg-oos-wh]');
    for (var anElement of whs) {
        let list = anElement.dataset.fgOosWh;
        if (fgCurrentWarehouse() && list.indexOf(fgCurrentWarehouse()) >= 0) {
            unavailableByWh.push(anElement);
        }
    }
    console.log(`Disabling ${unavailableByWh.length} wines Out of Stock in wh ${fgCurrentWarehouse()}`);
    fgDisableElements(unavailableByWh, 'Out of Stock');
}

function fgCurrentWarehouse() {
    return fg_wh;
}

function fgCurrentState() {
    return localStorage.getItem('fgw_state');
}

document.addEventListener('DOMContentLoaded', () => {
    const stateSelects = document.querySelectorAll('select.fgw_state_select');
    if (localStorage.getItem('fgw_state')) {
        stateSelects.forEach((ss) => ss.value = localStorage.getItem('fgw_state'));
    }
    stateSelects.forEach((ss) => ss.addEventListener('change', (event) => {
        const stateSelected = event.target.value;
        window.localStorage.setItem('fgw_state', stateSelected);
        document.dispatchEvent(new CustomEvent('fgw_state_change', { 'new_state': stateSelected }));
    }));

    document.addEventListener('fgw_state_change', (event) => {
        const stateSelected = window.localStorage.getItem('fgw_state');
        const stateSelects  = document.querySelectorAll('select.fgw_state_select');
        if (stateSelects && stateSelected) {
            stateSelects.forEach((ss) => ss.value = stateSelected);
        }
        setCurrentWarehouse();
        fgCheckAvailability();
    });

    setCurrentWarehouse();
    fgCheckAvailability();
});

